/* src/app/front-layout/academy/academy.component.css */
/*# sourceMappingURL=academy.component.css.map */
